import { Component, computed, input, Input, InputSignal, OnInit, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';
import { AccordionGroupComponent } from '../../../../../common/accordion-group/accordion-group.component';
import {
  AdPlacementRoadOccupationFormValue, occupationsToAdPlacementRoadOccupationFormValues
} from '../sections/ad-placement-section/forms/ad-placement-road-occupation.form';
import { AccordionItemComponent } from '../../../../../common/accordion-item/accordion-item.component';
import {
  AdPlacementOccupationPreviewComponent
} from '../sections/ad-placement-section/components/ad-placement-occupation-preview/ad-placement-occupation-preview.component';

@Component({
  selector: 'app-placement-advertising-preview',
  standalone: true,
  imports: [
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    ContractorDataPreviewComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    AdPlacementOccupationPreviewComponent
  ],
  templateUrl: './placement-advertising-preview.component.html'
})
export class PlacementAdvertisingPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public roadOccupations: Signal<AdPlacementRoadOccupationFormValue[]> = computed(() => occupationsToAdPlacementRoadOccupationFormValues(this.application()))

  constructor() {
  }

  public ngOnInit(): void {
  }
}
